import { render, staticRenderFns } from "./TraumaSeverityScore.vue?vue&type=template&id=4bc8477d&scoped=true&"
import script from "./TraumaSeverityScore.vue?vue&type=script&lang=js&"
export * from "./TraumaSeverityScore.vue?vue&type=script&lang=js&"
import style0 from "./TraumaSeverityScore.vue?vue&type=style&index=0&id=4bc8477d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc8477d",
  null
  
)

export default component.exports